import * as React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import '../assets/css/home.css';
import { RouteComponentProps } from 'react-router';
import appConfigs from '../../../../config.json';
import StaticImageSlider from '../../../../components/StaticImageSlider';
import { IUserState } from '../../../../store/reducers/userReducer';
import flowimg from '../assets/img/bg.jpg';
import mhi from "../assets/img/slider-dec-v3.png";
import Footer from '../Footer';
import ImageSlider from '../../../../components/ImageSlider';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import { Box } from '@material-ui/core';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Header from '../Header';
import RequestDemo from '../../../../components/CMSApp/RequestDemo';
type thisProps = RouteComponentProps;
interface PageState {
  showComponenrt: boolean;
  SelectedTabValue: string;


}

class Contact extends React.Component<thisProps, PageState> {
  constructor(props) {
    super(props);
    this.state = {
      showComponenrt: false,
      SelectedTabValue: "1",

    };
  }
  public async componentDidMount() {
    document.title =  appConfigs.CompanyTitle;

  }

  public render() {
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
      this.setState({ SelectedTabValue: newValue });
    };
    /*  const [name, setName] = useState("555"); */
    //  const userJwt = useSelector((state: IAppState) => state.UserState?state.UserState.jwt:null); -fluid-inner
    return (
      <div dir='ltr' id='page-about' >
   <Header />
 
        <main id="main">
{/*         <section id="contact2" className="contact2">

<div className="container" data-aos="fade-up" hidden>

  <header className="section-header">
    <h2>    
    </h2>
    <p> درخواست دمو  
    </p>
  </header>

  <div className="row gy-4">
    <div className="col-lg-12" >

   <RequestDemo  ></RequestDemo>



   </div>
   </div>
</div>

</section> */}
          <section id="contact" className="contact">

            <div className="container" data-aos="fade-up">

              <header className="section-header">
                <h2>   راه ارتباط با ما
                </h2>
                <p>اطلاعات تماس
                </p>
              </header>

              <div className="row gy-4">
                <div className="col-lg-6">

                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d404.83644351898636!2d51.41763752997152!3d35.73380375800187!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2s!4v1704699991936!5m2!1sen!2s"
                    width="100%"
                    height="450"
                    className="border-0"
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>

                </div>
                <div className="col-lg-6">

                  <div className="row gy-4">
                    <div className="col-md-6">
                      <div className="info-box">
                        <i className="bi bi-geo-alt"></i>
                        <h3>آدرس</h3>
                        <p>تهران، میدان آرژانتین، خیابان 16 غربی، پلاک 8، طبقه 2
                          <br />    شرکت تجارت الکترونیک هوشمند تمدن
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="info-box">
                        <i className="bi bi-telephone"></i>
                        <h3>   اطلاعات تماس</h3>
                        <p>021-58169998

                          <br /></p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="info-box">
                        <i className="bi bi-envelope"></i>
                        <h3>ایمیل</h3>
                        <p>info@tamadonsec.ir<br /></p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="info-box">
                        <i className="bi bi-clock"></i>
                        <h3>  ساعات کاری</h3>
                        <p>شنبه - چهارشنبه<br /> 8 صبح - 5 بعد از ظهر</p>
                      </div>
                    </div>
                  </div>

                </div>



              </div>

            </div>

          </section>

        </main>
        <Footer />
      </div>
    );
  };
}
export default connect()(Contact);
